module.exports = __webpack_public_path__ + "static/img/irole.035d6da.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/tsz/irole.png
// module id = yeeG
// module chunks = 7